<template>
  <v-card
    @click="viewBillDetails(bill.id)"
    class="mt-4"
    :style="{
      'border-left': `8px solid ${borderColor}`,
    }"
  >
    <v-row class="d-flex align-center mr-1 mr-md-0">
      <v-col cols="7" sm="7" md="7" class="pl-1 pr-0 pr-md-3">
        <v-card-text class="d-flex align-center">
          <div class="justify-center mr-4 d-none d-md-flex"
            :style="`--element-color: ${bill.estado === 3 ? '#E8F5E9' : '#E3F2FD'}`">
            <v-icon class="pa-2 rounded-pill" :color="billIconColor">
              {{ billIcon }}
            </v-icon>
          </div>
          <div class="d-flex flex-column">
            <span class="text-subtitle-1 text-md-h6 font-weight-medium bill-text">
              Factura {{ bill.descripcion_estado?.toLowerCase() }}
            </span>
            <span class="text-subtitle-2 font-weight-regular blue--text text--darken-2"
              >Fact. {{ bill.nro_factura }}
            </span>
          </div>
        </v-card-text>
      </v-col>
      <v-col cols="4" sm="4" md="4" class="px-0 px-md-3">
        <div class="d-flex flex-column text-end">
          <h6 class="text-subtitle-1 text-md-h6 font-weight-medium grey--text text--darken-1 short-text">
            $ {{ bill.monto_factura }}
          </h6>
          <span
            v-if="bill.fecha_pago"
            style="text-wrap: nowrap"
            class="grey--text text--darken-1"
            >Cobrado el {{ bill.fecha_pago | formatDateShort }}</span
          >
        </div>
      </v-col>
      <v-col cols="1" class="px-0 px-md-3">
        <v-icon color="blue darken-2"
          >chevron_right</v-icon
        >
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: "BillCard",
  props: {
    bill: Object,
    required: true,
  },
  computed: {
    borderColor() {
      const COLORS = {
        0: "#1976D2",
        1: "#1976D2",
        2: "#1976D2",
        3: "#4CAF50",
      };

      return COLORS[this.bill.estado] || "#1976D2";
    },
    billIcon() {
      const ICON = {
        0: "history",
        1: "history",
        2: "history",
        3: "check",
      };

      return ICON[this.bill.estado] || "history";
    },
    billIconColor() {
      const COLOR = {
        0: "blue darken-2",
        1: "blue darken-2",
        2: "blue darken-2",
        3: "light-green darken-4",
      };
      return COLOR[this.bill.estado] || "blue darken-2";
    },
  },
  methods: {
    viewBillDetails(id) {
      this.$router.push({ name: "bill-details", params: { id } });
    },
  },
};
</script>

<style scoped>
@media (max-width: 959px) {
  .bill-text {
    line-height: normal !important;
  }
  .short-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

@media (min-width: 960px) {
  .bill-text {
    line-height: 2rem !important;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.v-icon {
  background-color: var(--element-color);
}
</style>
